import React, { Component, PropTypes } from 'react';
import { defaultSsgFormStyle, formElements, SsgFormComponent } from '@social-solutions/ssg-forms';
import confirmedFormDef from './confirmed-form-definition';

const formId = 'confirmed-form';

/**
 * Simple view-only screen that is displayed after the user
 * chooses yes or no on the unsubscription confirmation page.
 */
export class ConfirmedForm extends Component {

  render() {
    const { title } = this.props;

    // set unique form elements styles
    var confirmedNoticeStyle = Object.assign({}, formElements.defaultElementStyles.specialText);
    confirmedNoticeStyle.label += " opt-out-confirm-input-label normal-wrap";
    var formElementStyles = Object.assign({}, formElements.defaultElementStyles);
    formElementStyles.specialText = confirmedNoticeStyle;

    // set form style
    var formStyle = {
      actions: defaultSsgFormStyle.actions + " opt-out-confirm-action-bar",
      primaryButton: defaultSsgFormStyle.primaryButton + " opt-out-confirm-form-button",
      title: defaultSsgFormStyle.title += " opt-out-confirm-header",
    };

    var formDefWithTitle = confirmedFormDef;
    formDefWithTitle.name = title ? title : "Confirmed";

    const formProps = {
      id: formId,
      form: formDefWithTitle,
      disableValidationResultList: true,
      buttonLayout: [
      ],
      elementStyles: formElementStyles,
      css: formStyle
    }

    return (
      <div id="opt-out-confirm-form">
        <SsgFormComponent {...formProps}/>
      </div>
    )
  }
}

ConfirmedForm.propTypes = {
 title: PropTypes.string,
};

export default (ConfirmedForm);



// WEBPACK FOOTER //
// src/acct/opt-out/confirmed-form.js